exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles-href-1fNufSlc {\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  outline: none;\n  -webkit-text-decoration: none;\n  text-decoration: none;\n}\n", ""]);

// exports
exports.locals = {
	"href": "styles-href-1fNufSlc"
};